import React from 'react';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
//import 'react-tabs/style/react-tabs.css';
import Dropdown from 'react-dropdown';
import { SketchPicker } from 'react-color';
import { CmnCustomizeCard, UpgradePlanCard } from '../../components';
// import './Wall.scss';
import { Normal, Bold, Italic, Underline } from '../../img';
import { PostToggleCard } from '../../components';


const fontOption = [
  { value: 'lato', label: 'Lato' },
  {
    value: 'Roboto, sans-serif', label: 'Roboto'
  },
  { value: 'raleway', label: 'Raleway' },
  { value: 'poppins', label: 'Poppins' },
  { value: ' ', label: 'Website Font' },
];

const brdSizeOption = [
  { value: '0', label: '0' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
];

const brdStylOption = [
  { value: 'solid', label: 'Solid' },
  { value: 'dashed', label: 'Dashed' },
  { value: 'dotted', label: 'Dotted' }

];

const tabbrdRdsOption = [
  { value: '0', label: '0' },
  { value: '3', label: '3' },
  { value: '6', label: '6' },
  { value: '9', label: '9' },
  { value: '11', label: '11' },
  { value: '14', label: '14' },
  { value: '17', label: '17' },
  { value: '20', label: '20' },
];

const brdRdsOption = [
  { value: '0', label: '0' },
  { value: '5', label: '5' },
  { value: '10', label: '10' },
  { value: '15', label: '15' },
  { value: '20', label: '20' },
  { value: '25', label: '25' },
  { value: '30', label: '30' },
];

const shdOption = [
  { value: '-30', label: '-30' },
  { value: '-27', label: '-27' },
  { value: '-24', label: '-24' },
  { value: '-21', label: '-21' },
  { value: '-18', label: '-18' },
  { value: '-15', label: '-15' },
  { value: '-12', label: '-12' },
  { value: '-9', label: '-9' },
  { value: '-6', label: '-6' },
  { value: '-3', label: '-3' },
  { value: '0', label: '0' },
  { value: '3', label: '3' },
  { value: '6', label: '6' },
  { value: '9', label: '9' },
  { value: '12', label: '12' },
  { value: '15', label: '15' },
  { value: '18', label: '18' },
  { value: '21', label: '21' },
  { value: '24', label: '24' },
  { value: '27', label: '27' },
  { value: '30', label: '30' },
];

const shdblrOption = [
  { value: '0', label: '0' },
  { value: '3', label: '3' },
  { value: '6', label: '6' },
  { value: '9', label: '9' },
  { value: '12', label: '12' },
  { value: '15', label: '15' },
  { value: '18', label: '18' },
  { value: '21', label: '21' },
  { value: '24', label: '24' },
  { value: '27', label: '27' },
  { value: '30', label: '30' }
];

const fszOption = [
  { value: '12', label: '12' },
  { value: '14', label: '14' },
  { value: '16', label: '16' },
  { value: '18', label: '18' },
  { value: '20', label: '20' }
];

const fsylOption = [
  { value: 'normal', label: <img className='fnt-style-Icn' src={Normal} /> },
  { value: 'bold', label: <img className='fnt-style-Icn' src={Bold} /> },
  { value: 'italic', label: <img className='fnt-style-Icn' src={Italic} /> },
  { value: 'underline', label: <img className='fnt-style-Icn' src={Underline} /> },
];

//animition for desktop
const Animation = [
  { value: 'fade', label: 'Fade' },
  { value: 'bounce', label: 'Bounce' },
  { value: 'zoom', label: 'Zoom' },
  { value: 'zoom_in_down', label: 'Zoom In Down' },
  { value: 'slide', label: 'Slide' },
  { value: 'horizonatal_slide', label: 'Slide Horizontal' },
  { value: 'side_flip_in', label: 'Slide Flip In' },
  { value: 'side_flip_back', label: 'Slide Flip Back' },
  { value: 'flip', label: 'Flip' },
  { value: 'up_flip', label: 'Flip Up' },
  { value: 'back_flip', label: 'Flip Back' },
];

const Position = [
  { value: 'left_top', label: 'Left top' },
  // { value: 'center_top', label: 'Center top' },
  { value: 'right_top', label: 'Right top' },
  // { value: 'left_center', label: 'Left center' },
  // { value: 'center', label: 'Center' },
  // { value: 'right_center', label: 'Right center' },
  { value: 'left_bottom', label: 'Left bottom' },
  // { value: 'center_bottom', label: 'Center bottom' },
  { value: 'right_bottom', label: 'Right bottom' }
];

let fontSize = [
  { value: '10', label: '10px' },
  { value: '12', label: '12px' },
  { value: '13', label: '13px' },
  { value: '14', label: '14px' },
  { value: '16', label: '16px' },
  { value: '18', label: '18px' },
  { value: '20', label: '20px' },
  { value: '22', label: '22px' },
  { value: '24', label: '24px' },
  { value: '26', label: '26px' },
  { value: '28', label: '28px' },
];

const AppearanceCard = ({
  cnf,
  colorPick,
  handleColorPicker,
  // handleColorPickerClose,
  handleCnfChange,
  currPopup,
  fnCheckFieldIsDisplayOrNot,
  currCategory,
  currLayout,
  wdtnm,
  handleTabchange,
  currCardId,
  handleUpgradePlan
}) => {
  return (
    <Tabs className={cnf && (cnf.crdclkact == '2' && fnCheckFieldIsDisplayOrNot('cnf.crdclkact', currLayout)) ? 'nf-default-tabs wg-default-editor' : 'nf-default-tabs wg-default-editor nf-default-tabstwopanel'}>
      <TabList className="wg-tabs-secstyle wg-tabs-appearance">
        <div className="sidebar-aniborder-block" id="Wdgt-Tab-appearance"></div>
        <Tab onClick={() => handleTabchange('layout', 'appearance', cnf.crdclkact)}>
          Layout
        </Tab>
        <Tab onClick={() => handleTabchange('card', 'appearance', cnf.crdclkact)}>
          Card
        </Tab>
        {cnf && cnf.crdclkact == '2' && fnCheckFieldIsDisplayOrNot('cnf.crdclkact', currLayout) &&
          <Tab onClick={() => handleTabchange('popup', 'appearance', cnf.crdclkact)}>
            Popup
          </Tab>
        }
      </TabList>
      {/* Layout */}
      <TabPanel className="tabs-secstyle-panel tabs-panel-appearance">
        <div className="card card-editor card-customize mt-15">
          <div className="card-editor-block p-0">
            <div className='card-plan-div'>
              <label className="card-editor-title">Theme option</label>
              <UpgradePlanCard
                handleUpgradePlan={handleUpgradePlan}
              />
            </div>
            <div className="customize-list">
              {cnf && cnf.lyclrtyp != undefined &&
                <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                  <label className="label-title">Color scheme</label>
                  <div className="d-flex">
                    <div className={cnf.lyclrtyp == '1' ? 'squre-rect-item squre-rect-dark mr-3 active' : 'squre-rect-item squre-rect-dark mr-3'} onClick={() => handleCnfChange('lyclrtyp', '1')}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14.002" height="10.628" viewBox="0 0 14.002 10.628">
                        <path id="Subtraction_1" data-name="Subtraction 1" d="M-11503-4670a7.008,7.008,0,0,1-7-7c0-.12,0-.243.01-.378A6.953,6.953,0,0,0-11504-4674a6.994,6.994,0,0,0,6.99-6.627A6.988,6.988,0,0,1-11496-4677,7.008,7.008,0,0,1-11503-4670Z" transform="translate(11510 4680.627)" fill="#90adcc" />
                      </svg>
                    </div>
                    <div className={cnf.lyclrtyp == '2' ? 'squre-rect-item squre-rect-light active' : 'squre-rect-item squre-rect-light'} onClick={() => handleCnfChange('lyclrtyp', '2')}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 12.599 12.6">
                        <g id="Group_8169" data-name="Group 8169" transform="translate(1.708 1.725)">
                          <g id="Group_8153" data-name="Group 8153" transform="translate(1.425 1.408)">
                            <circle id="Ellipse_163" data-name="Ellipse 163" cx="3.165" cy="3.165" r="3.165" transform="translate(-0.133 -0.133)" fill="#90adcc" />
                          </g>
                          <path id="Path_12721" data-name="Path 12721" d="M252.517,140.8h-1.283a.433.433,0,0,0,0,.867h1.283a.433.433,0,1,0,0-.867Z" transform="translate(-242.059 -136.658)" fill="#90adcc" />
                          <path id="Path_12722" data-name="Path 12722" d="M141.233,250.8a.441.441,0,0,0-.433.433v1.283a.433.433,0,0,0,.867,0v-1.283A.441.441,0,0,0,141.233,250.8Z" transform="translate(-136.642 -242.075)" fill="#90adcc" />
                          <path id="Path_12723" data-name="Path 12723" d="M220.242,219.642l-.917-.917a.424.424,0,1,0-.6.6l.917.917a.424.424,0,0,0,.6-.6Z" transform="translate(-211.2 -211.217)" fill="#90adcc" />
                          <path id="Path_12724" data-name="Path 12724" d="M141.233,0a.441.441,0,0,0-.433.433V1.717a.433.433,0,0,0,.867,0V.433A.441.441,0,0,0,141.233,0Z" transform="translate(-136.642 -1.725)" fill="#90adcc" />
                          <path id="Path_12725" data-name="Path 12725" d="M220.642,41.525a.423.423,0,0,0-.6,0l-.917.917a.424.424,0,0,0,.6.6l.917-.917A.423.423,0,0,0,220.642,41.525Z" transform="translate(-211.583 -41.4)" fill="#90adcc" />
                          <path id="Path_12726" data-name="Path 12726" d="M1.717,140.8H.433a.441.441,0,0,0-.433.433.43.43,0,0,0,.433.433H1.717a.433.433,0,0,0,0-.867Z" transform="translate(-1.708 -136.658)" fill="#90adcc" />
                          <path id="Path_12727" data-name="Path 12727" d="M42.642,218.725a.422.422,0,0,0-.6,0l-.917.917a.424.424,0,1,0,.6.6l.917-.917A.423.423,0,0,0,42.642,218.725Z" transform="translate(-41 -211.217)" fill="#90adcc" />
                          <path id="Path_12728" data-name="Path 12728" d="M42.642,42.442l-.917-.917a.424.424,0,1,0-.6.6l.917.917a.424.424,0,0,0,.6-.6Z" transform="translate(-41 -41.4)" fill="#90adcc" />
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              }
              {cnf && cnf.bgclr != undefined &&
                <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                  <label className="label-title">Background color</label>
                  <div className="d-flex">
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('bgclr')} style={{ background: cnf.bgclr }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'bgclr' ?
                          <div className="colorPickPopover" >
                            <SketchPicker color={cnf.bgclr} onChange={(e) => handleCnfChange('bgclr', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              }
              {cnf && cnf.lyfnfml != undefined &&
                <div className="editor-field-list editor-dropdown">
                  <label>Font Family</label>
                  <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fontOption} value={cnf.lyfnfml} onChange={(e) => handleCnfChange('lyfnfml', e.value)} />
                </div>
              }
            </div>
          </div>
        </div>

        {(currCategory.cn == 'review' || currCategory.cn == 'social') &&
          <div className="card card-editor card-customize mt-15">
            <div className="card-editor-block p-0">
              <div className='card-plan-div'>
                <label className="card-editor-title">Header</label>
                <UpgradePlanCard
                  handleUpgradePlan={handleUpgradePlan}
                />
              </div>
              <div className='customize-list'>
                {
                  wdtnm == 'allinonereview' &&
                  <div className='customize-list'>
                    <CmnCustomizeCard
                      label={'Tab'}
                      ddnValue={cnf.cmntbddn}
                      ddnField={'cmntbddn'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmntbclr'}
                      clrValue={cnf.cmntbclr} />
                  </div>
                }
                <CmnCustomizeCard
                  label={'Header Title'}
                  ddnValue={cnf.cmnhdrddna}
                  ddnField={'cmnhdrddna'}
                  handleCnfChange={handleCnfChange}
                  handleColorPicker={handleColorPicker}
                  colorPick={colorPick}
                  clrField={'cmnhdrclra'}
                  clrValue={cnf.cmnhdrclra} />

                <CmnCustomizeCard
                  label={'Header Caption'}
                  ddnValue={cnf.cmnhdrddnb}
                  ddnField={'cmnhdrddnb'}
                  handleCnfChange={handleCnfChange}
                  handleColorPicker={handleColorPicker}
                  colorPick={colorPick}
                  clrField={'cmnhdrclrb'}
                  clrValue={cnf.cmnhdrclrb} />
              </div>
            </div>
          </div>
        }

        {cnf && fnCheckFieldIsDisplayOrNot('arrow_bg', currLayout) &&
          <div className="card card-editor card-customize mt-15">
            <div className="card-editor-block p-0">
              <div className='card-plan-div'>
                <label className="card-editor-title">Slider Arrow</label>
                <UpgradePlanCard
                  handleUpgradePlan={handleUpgradePlan}
                />
              </div>
              <div className="customize-list">
                {cnf && cnf.arwbgclr != undefined &&
                  <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                    <label className="label-title">Arrow Background-color</label>
                    <div className="d-flex">
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('arwbgclr')} style={{ background: cnf.arwbgclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'arwbgclr' ?
                            <div className="colorPickPopover" >
                              <SketchPicker color={cnf.arwbgclr} onChange={(e) => handleCnfChange('arwbgclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }
                {cnf && cnf.arwclr != undefined &&
                  <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                    <label className="label-title">Arrow color</label>
                    <div className="d-flex">
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('arwclr')} style={{ background: cnf.arwclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'arwclr' ?
                            <div className="colorPickPopover" >
                              <SketchPicker color={cnf.arwclr} onChange={(e) => handleCnfChange('arwclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }


        {wdtnm == 'allinonereview' && cnf.rvitb == true &&
          <div className="card card-editor card-customize mt-15">
            <div className="card-editor-block p-0">
              <div className='card-plan-div'>
                <label className="card-editor-title">Header Tabs</label>
                <UpgradePlanCard
                  handleUpgradePlan={handleUpgradePlan}
                />
              </div>
              <div className="customize-list">
                {cnf && cnf.rvallbrdrdus != undefined &&
                  <div className="editor-field-list editor-dropdown">
                    <label>Border radius</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={tabbrdRdsOption} value={cnf.rvallbrdrdus != undefined ? cnf.rvallbrdrdus.toString() : cnf.rvallbrdrdus} onChange={(e) => handleCnfChange('rvallbrdrdus', e.value)} />
                  </div>
                }
                {cnf && cnf.rvallbrdclr != undefined &&
                  <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                    <label className="label-title">Border color</label>
                    <div className="d-flex">
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('rvallbrdclr')} style={{ background: cnf.rvallbrdclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'rvallbrdclr' ?
                            <div className="colorPickPopover" >
                              <SketchPicker color={cnf.rvallbrdclr} onChange={(e) => handleCnfChange('rvallbrdclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        {cnf && fnCheckFieldIsDisplayOrNot('position', currLayout) &&
          <div className="card card-editor card-customize mt-15">
            <div className="card-editor-block p-0">
              <div className='card-plan-div'>
                <label className="card-editor-title">Position & Animation in Desktop</label>
                <UpgradePlanCard
                  handleUpgradePlan={handleUpgradePlan}
                />
              </div>
              <div className="customize-list">
                <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                  <label className="label-title">Show</label>
                  <label className="switch">
                    <input type="checkbox" checked={cnf.isdsk} onChange={(e) => handleCnfChange('isdsk', e.target.checked)} />
                    <span className="slider round"></span>
                  </label>
                </div>
                {cnf.isdsk == true &&
                  <div>
                    <div className="editor-field-list editor-dropdown customize-dropdown customize-dropd-deskanim">
                      <label>Animation</label>
                      <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={Animation} value={cnf.dskanm} onChange={(e) => handleCnfChange('dskanm', e.value)} />
                    </div>
                    <div className="editor-field-list editor-dropdown customize-dropdown customize-dropd-deskpos">
                      <label>Position</label>
                      <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={Position} value={cnf.dskpos} onChange={(e) => handleCnfChange('dskpos', e.value)} />
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        {cnf && fnCheckFieldIsDisplayOrNot('position', currLayout) &&
          <div className="card card-editor card-customize mt-15">
            <div className='card-plan-div'>
              <label className="card-editor-title">Position & Animation in Mobile</label>
              <UpgradePlanCard
                handleUpgradePlan={handleUpgradePlan}
              />
            </div>
            <div className="customize-list">
              <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                <label className="label-title">Show</label>
                <label className="switch">
                  <input type="checkbox" checked={cnf.ismbl} onChange={(e) => handleCnfChange('ismbl', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div>
              {cnf.ismbl == true &&
                <div>
                  <div className="editor-field-list editor-dropdown customize-dropdown customize-dropd-mobianim">
                    <label>Animation</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={Animation} value={cnf.mblanm} onChange={(e) => handleCnfChange('mblanm', e.value)} />
                  </div>
                  <div className="editor-field-list editor-dropdown customize-dropdown customize-dropd-mobipos">
                    <label>Position</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={Position} value={cnf.mblpos} onChange={(e) => handleCnfChange('mblpos', e.value)} />
                  </div>
                </div>
              }
            </div>
          </div>
        }

        {cnf && !fnCheckFieldIsDisplayOrNot('position', currLayout) &&
          <div className="card card-editor card-customize mt-15" >
            <div className="card-editor-block p-0">
              <div className='card-plan-div'>
                <label className="card-editor-title">Display on</label>
                <UpgradePlanCard
                  handleUpgradePlan={handleUpgradePlan}
                />
              </div>
              <div className="customize-list">
                {cnf.isdsk != undefined &&
                  <PostToggleCard
                    ttl={'Desktop'}
                    fieldName={'isdsk'}
                    value={cnf.isdsk}
                    handleCnfChange={handleCnfChange} />
                  // <div className="editor-field-list editor-toggle">
                  //   <label className="label-title">On desktop</label>
                  //   <label className="switch">
                  //     <input type="checkbox" checked={cnf.isdsk} onChange={(e) => handleCnfChange('isdsk', e.target.checked)} />
                  //     <span className="slider round"></span>
                  //   </label>
                  // </div>
                }
                {cnf.ismbl != undefined &&
                  <PostToggleCard
                    ttl={'Mobile'}
                    fieldName={'ismbl'}
                    value={cnf.ismbl}
                    handleCnfChange={handleCnfChange} />
                  // <div className="editor-field-list editor-toggle">
                  //   <label className="label-title">On mobile</label>
                  //   <label className="switch">
                  //     <input type="checkbox" checked={cnf.ismbl} onChange={(e) => handleCnfChange('ismbl', e.target.checked)} />
                  //     <span className="slider round"></span>
                  //   </label>
                  // </div>
                }
              </div>
            </div>
          </div>
        }

        {/* CTA label */}
        {(cnf.tlsbtnbgclr != undefined || cnf.tlsbtnfntclr != undefined) &&
          <div className="card card-editor mt-15">
            <div className="card-editor-block p-0">
              <div className='card-plan-div'>
                <label className="card-editor-title">CTA label</label>
                <UpgradePlanCard
                  handleUpgradePlan={handleUpgradePlan}
                />
              </div>
              <div className="customize-list">
                {cnf.tlsbtnfntclr != undefined &&
                  <div className="editor-field-list editor-toggle customize-dropdown customize-ctalabel">
                    <label className="label-title">Font</label>
                    <div className="d-flex editor-cardcmn-fntclr">
                      {cnf.tlsbtnfntsz &&
                        <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3">
                          <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fontSize} value={cnf.tlsbtnfntsz ? cnf.tlsbtnfntsz.toString() : cnf.tlsbtnfntsz} onChange={(e) => handleCnfChange('tlsbtnfntsz', e.value)} />
                        </div>
                      }
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('tlsbtnfntclr')} style={{ background: cnf.tlsbtnfntclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'tlsbtnfntclr' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.tlsbtnfntclr} onChange={(e) => handleCnfChange('tlsbtnfntclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }
                {cnf.tlsbtnbgclr != undefined &&
                  <div className="editor-field-list editor-toggle customize-dropdown customize-authoricon">
                    <label className="label-title">Background color</label>
                    <div className="d-flex">
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('tlsbtnbgclr')} style={{ background: cnf.tlsbtnbgclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'tlsbtnbgclr' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.tlsbtnbgclr} onChange={(e) => handleCnfChange('tlsbtnbgclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }
                {/* <div className="editor-toggle customize-dropdown customize-showarrow">
                  <label className="label-title">Open in same tab</label>
                  <label className="switch">
                    <input type="checkbox" checked={cnf.tlsbtnclksmtb} onChange={(e) => handleCnfChange('tlsbtnclksmtb', e.target.checked)} />
                    <span className="slider round"></span>
                  </label>
                </div> */}
              </div>
            </div>
          </div>
        }

        {cnf && cnf.icss != undefined &&
          <div className="card card-editor card-customize mt-15">
            <div className="card-editor-block p-0">
              <div className='card-plan-div'>
                <label className="card-editor-title">Custom CSS</label>
                <UpgradePlanCard
                  handleUpgradePlan={handleUpgradePlan}
                />
              </div>
              <div className="customize-list ">
                <div className="editor-field-list editor-input header-editor-input editor-custom-css">
                  <label className="label-title">Add CSS</label>
                  <div className="customize-css-toggle">
                    <label className="switch">
                      <input type="checkbox" checked={cnf.icss} onChange={(e) => handleCnfChange('icss', e.target.checked)} />
                      <span className="slider round"></span>
                    </label>
                  </div>
                  {cnf && cnf.icss == true &&
                    <textarea className="form-control" rows="4" value={cnf.ccss} onChange={(e) => handleCnfChange('ccss', e.target.value)}></textarea>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </TabPanel>
      {/* Card */}
      <TabPanel className="tabs-secstyle-panel tabs-panel-appearance">
        {cnf && cnf.crdbg != undefined &&
          <div className="card card-editor card-bgcard mt-15">
            <div className="card-editor-block card-customize">
              <div className='card-plan-div'>
                <label className="card-editor-title">Background</label>
                <UpgradePlanCard
                  handleUpgradePlan={handleUpgradePlan}
                />
              </div>
              <div className="customize-list ">
                <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow mb-0">
                  <label className="label-title">Color</label>
                  <div className="d-flex">
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('crdbg')} style={{ background: cnf.crdbg }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'crdbg' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.crdbg} onChange={(e) => handleCnfChange('crdbg', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        {cnf &&
          <div className="card card-editor card-bgcard mt-15">
            <div className="card-editor-block p-0 ">
              <div className='card-plan-div'>
                <label className="card-editor-title">Border</label>
                <UpgradePlanCard
                  handleUpgradePlan={handleUpgradePlan}
                />
              </div>
              <div className="customize-list">
                <div className="editor-field-list editor-toggle border-dropdown border-dropdown-clr mb-0">
                  <label className="label-title">Color</label>
                  <div className="d-flex">
                    <div className={cnf.crdbrdrd == '0' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('crdbrdrd', '0')}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="13.333" height="13.333" viewBox="0 0 13.333 13.333">
                        <path id="Path_12730" data-name="Path 12730" d="M2.5,4.167V17.5H4.068V5.735H15.833V4.167Z" transform="translate(-2.5 -4.167)" fill="#90adcc" fillRule="evenodd" />
                      </svg>
                    </div>
                    <div className={cnf.crdbrdrd == '5' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('crdbrdrd', '5')}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="13.333" height="13.333" viewBox="0 0 13.333 13.333">
                        <path id="Path_12731" data-name="Path 12731" d="M8.513,4.167A6.013,6.013,0,0,0,2.5,10.006l0,.174V17.5H4.068V10.18A4.445,4.445,0,0,1,8.357,5.738l.156,0h7.32V4.167Z" transform="translate(-2.5 -4.167)" fill="#90adcc" fillRule="evenodd" />
                      </svg>
                    </div>
                    <div className={cnf.crdbrdrd == '15' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('crdbrdrd', '15')}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="13.333" height="13.333" viewBox="0 0 13.333 13.333">
                        <path id="Path_12732" data-name="Path 12732" d="M15.049,4.167A12.549,12.549,0,0,0,2.5,16.493l0,.223V17.5H4.068v-.784A10.982,10.982,0,0,1,14.838,5.737l.21,0h.785V4.167Z" transform="translate(-2.5 -4.167)" fill="#90adcc" fillRule="evenodd" />
                      </svg>
                    </div>
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('crdbrdclr')} style={{ background: cnf.crdbrdclr }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'crdbrdclr' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.crdbrdclr} onChange={(e) => handleCnfChange('crdbrdclr', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
                <div className="editor-tworow-part editor-tworow-border pb-0 px-0">
                  <div className="editor-tworow-block pb-0">
                    <div className="editor-tworow-col editor-tworow-bdrclr">
                      <label className="label-title">Size</label>
                      <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={brdSizeOption} value={cnf.crdbrdsz != undefined ? cnf.crdbrdsz.toString() : cnf.crdbrdsz} onChange={(e) => handleCnfChange('crdbrdsz', e.value)} />
                    </div>
                    <div className="editor-tworow-col editor-tworow-bdrsize">
                      <label className="label-title">Style</label>
                      <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={brdStylOption} value={cnf.crdbrdstl} onChange={(e) => handleCnfChange('crdbrdstl', e.value)} />
                    </div>
                    <div className="editor-tworow-col editor-tworow-style">
                      <label className="label-title">Radius</label>
                      <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={brdRdsOption} value={cnf.crdbrdrd != undefined ? cnf.crdbrdrd.toString() : cnf.crdbrdrd} onChange={(e) => handleCnfChange('crdbrdrd', e.value)} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        {cnf &&
          <div className="card card-editor card-bgcard mt-15">
            <div className="card-editor-block p-0">
              <div className='card-plan-div'>
                <label className="card-editor-title">Shadow</label>
                <UpgradePlanCard
                  handleUpgradePlan={handleUpgradePlan}
                />
              </div>
              <div className="customize-list">
                <div className="editor-field-list editor-toggle border-dropdown border-dropdown-clr mb-0">
                  <label className="label-title">Color</label>
                  <div className="d-flex">
                    <div className={cnf.crdshdvl == '0' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('crdshdnone')}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                        <g id="Rectangle_1639" data-name="Rectangle 1639" fill="none" stroke="#90adcc" strokeWidth="1">
                          <rect width="14" height="14" stroke="none" />
                          <rect x="0.5" y="0.5" width="13" height="13" fill="none" />
                        </g>
                      </svg>
                    </div>
                    <div className={cnf.crdshdvl == '6' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('crdshdleft')}>
                      <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
                        <defs>
                          <filter id="Path_12735" x="0" y="0" width="16" height="16" filterUnits="userSpaceOnUse">
                            <feOffset dx="2" dy="2" input="SourceAlpha" />
                            <feGaussianBlur result="blur" />
                            <feFlood floodOpacity="0.322" />
                            <feComposite operator="in" in2="blur" />
                            <feComposite in="SourceGraphic" />
                          </filter>
                        </defs>
                        <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_12735)">
                          <g id="Path_12735-2" data-name="Path 12735" fill="none">
                            <path d="M0,0H14V14H0Z" stroke="none" />
                            <path d="M 1 1 L 1 13 L 13 13 L 13 1 L 1 1 M 0 0 L 14 0 L 14 14 L 0 14 L 0 0 Z" stroke="none" fill="#90adcc" />
                          </g>
                        </g>
                      </svg>
                    </div>
                    <div className={cnf.crdshdvl == '-6' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('crdshdright')}>
                      <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
                        <defs>
                          <filter id="Path_12736" x="0" y="0" width="16" height="16" filterUnits="userSpaceOnUse">
                            <feOffset dx="-2" dy="-2" input="SourceAlpha" />
                            <feGaussianBlur result="blur" />
                            <feFlood floodOpacity="0.322" />
                            <feComposite operator="in" in2="blur" />
                            <feComposite in="SourceGraphic" />
                          </filter>
                        </defs>
                        <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_12736)">
                          <g id="Path_12736-2" data-name="Path 12736" transform="translate(2 2)" fill="none">
                            <path d="M0,0H14V14H0Z" stroke="none" />
                            <path d="M 1 1 L 1 13 L 13 13 L 13 1 L 1 1 M 0 0 L 14 0 L 14 14 L 0 14 L 0 0 Z" stroke="none" fill="#90adcc" />
                          </g>
                        </g>
                      </svg>
                    </div>
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('crdshdclr')} style={{ background: cnf.crdshdclr }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'crdshdclr' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.crdshdclr} onChange={(e) => handleCnfChange('crdshdclr', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
                <div className="editor-tworow-part editor-tworow-border pb-0 px-0">
                  <div className="editor-tworow-block pb-0 ">
                    <div className="editor-tworow-col editor-tworow-bdrclr">
                      <label className="label-title">Shadow-X</label>
                      <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={shdOption} value={cnf.crdshdhz != undefined ? cnf.crdshdhz.toString() : cnf.crdshdhz} onChange={(e) => handleCnfChange('crdshdhz', e.value)} />
                    </div>
                    <div className="editor-tworow-col editor-tworow-bdrsize">
                      <label className="label-title">Shadow-Y</label>
                      <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={shdOption} value={cnf.crdshdvl != undefined ? cnf.crdshdvl.toString() : cnf.crdshdvl} onChange={(e) => handleCnfChange('crdshdvl', e.value)} />
                    </div>
                    <div className="editor-tworow-col editor-tworow-style">
                      <label className="label-title">Blur</label>
                      <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={shdblrOption} value={cnf.crdshdblr != undefined ? cnf.crdshdblr.toString() : cnf.crdshdblr} onChange={(e) => handleCnfChange('crdshdblr', e.value)} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        {/* final code */}
        {currLayout.ltn !== 'single_h_slider' && currCategory.cn !== 'review' && currCategory.cn !== 'social' &&
          <div className="card card-editor card-bgcard mt-20">
            <div className='card-plan-div'>
              <label className="card-editor-title">Customize</label>
              <UpgradePlanCard
                handleUpgradePlan={handleUpgradePlan}
              />
            </div>
            {wdtnm == 'job_board' ?
              <div className="customize-list">
                <CmnCustomizeCard
                  label={'Header Title'}
                  ddnValue={cnf.cmnhdrddna}
                  ddnField={'cmnhdrddna'}
                  handleCnfChange={handleCnfChange}
                  handleColorPicker={handleColorPicker}
                  colorPick={colorPick}
                  clrField={'cmnhdrclra'}
                  clrValue={cnf.cmnhdrclra} />

                <CmnCustomizeCard
                  label={'Header Caption'}
                  ddnValue={cnf.cmnhdrddnb}
                  ddnField={'cmnhdrddnb'}
                  handleCnfChange={handleCnfChange}
                  handleColorPicker={handleColorPicker}
                  colorPick={colorPick}
                  clrField={'cmnhdrclrb'}
                  clrValue={cnf.cmnhdrclrb} />

                <CmnCustomizeCard
                  label={'Title'}
                  ddnValue={cnf.cmncrdddna}
                  ddnField={'cmncrdddna'}
                  handleCnfChange={handleCnfChange}
                  handleColorPicker={handleColorPicker}
                  colorPick={colorPick}
                  clrField={'cmncrdclra'}
                  clrValue={cnf.cmncrdclra} />

                <CmnCustomizeCard
                  label={'Location'}
                  ddnValue={cnf.cmncrdddnb}
                  ddnField={'cmncrdddnb'}
                  handleCnfChange={handleCnfChange}
                  handleColorPicker={handleColorPicker}
                  colorPick={colorPick}
                  clrField={'cmncrdclrb'}
                  clrValue={cnf.cmncrdclrb} />

                <CmnCustomizeCard
                  label={'Salary'}
                  ddnValue={cnf.cmncrdddnc}
                  ddnField={'cmncrdddnc'}
                  handleCnfChange={handleCnfChange}
                  handleColorPicker={handleColorPicker}
                  colorPick={colorPick}
                  clrField={'cmncrdclrc'}
                  clrValue={cnf.cmncrdclrc} />

                <CmnCustomizeCard
                  label={'Designation'}
                  ddnValue={cnf.cmncrdddnd}
                  ddnField={'cmncrdddnd'}
                  handleCnfChange={handleCnfChange}
                  handleColorPicker={handleColorPicker}
                  colorPick={colorPick}
                  clrField={'cmncrdclrd'}
                  clrValue={cnf.cmncrdclrd} />

                <CmnCustomizeCard
                  label={'Job type color'}
                  ddnValue={cnf.cmncrdddne}
                  ddnField={'cmncrdddne'}
                  handleCnfChange={handleCnfChange}
                  handleColorPicker={handleColorPicker}
                  colorPick={colorPick}
                  clrField={'cmncrdclre'}
                  clrValue={cnf.cmncrdclre} />

                <CmnCustomizeCard
                  label={'Description'}
                  ddnValue={cnf.cmncrdddnf}
                  ddnField={'cmncrdddnf'}
                  handleCnfChange={handleCnfChange}
                  handleColorPicker={handleColorPicker}
                  colorPick={colorPick}
                  clrField={'cmncrdclrf'}
                  clrValue={cnf.cmncrdclrf} />
              </div>
              :
              wdtnm == 'faq' ?
                <div className="customize-list">
                  <CmnCustomizeCard
                    label={'Header Title'}
                    ddnValue={cnf.cmnhdrddna}
                    ddnField={'cmnhdrddna'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmnhdrclra'}
                    clrValue={cnf.cmnhdrclra} />

                  <CmnCustomizeCard
                    label={'Header Caption'}
                    ddnValue={cnf.cmnhdrddnb}
                    ddnField={'cmnhdrddnb'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmnhdrclrb'}
                    clrValue={cnf.cmnhdrclrb} />

                  <CmnCustomizeCard
                    label={'Category'}
                    ddnValue={cnf.cmntbddn}
                    ddnField={'cmntbddn'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmntbclr'}
                    clrValue={cnf.cmntbclr} />

                  <CmnCustomizeCard
                    label={'Title'}
                    ddnValue={cnf.cmncrdddnb}
                    ddnField={'cmncrdddnb'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmncrdclrb'}
                    clrValue={cnf.cmncrdclrb} />

                  <CmnCustomizeCard
                    label={'Description'}
                    ddnValue={cnf.cmncrdddnc}
                    ddnField={'cmncrdddnc'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmncrdclrc'}
                    clrValue={cnf.cmncrdclrc} />
                </div>
                :
                wdtnm == 'tool_restaurant' ?
                  <div className="customize-list">
                    <CmnCustomizeCard
                      label={'Header Title'}
                      ddnValue={cnf.cmnhdrddna}
                      ddnField={'cmnhdrddna'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmnhdrclra'}
                      clrValue={cnf.cmnhdrclra} />

                    <CmnCustomizeCard
                      label={'Header Caption'}
                      ddnValue={cnf.cmnhdrddnb}
                      ddnField={'cmnhdrddnb'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmnhdrclrb'}
                      clrValue={cnf.cmnhdrclrb} />

                    <CmnCustomizeCard
                      label={'Category'}
                      ddnValue={cnf.cmntbddn}
                      ddnField={'cmntbddn'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmntbclr'}
                      clrValue={cnf.cmntbclr} />

                    <CmnCustomizeCard
                      label={'Title'}
                      ddnValue={cnf.cmncrdddnb}
                      ddnField={'cmncrdddnb'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmncrdclrb'}
                      clrValue={cnf.cmncrdclrb} />

                    <CmnCustomizeCard
                      label={'Price'}
                      ddnValue={cnf.cmncrdddnc}
                      ddnField={'cmncrdddnc'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmncrdclrc'}
                      clrValue={cnf.cmncrdclrc} />

                    <CmnCustomizeCard
                      label={'Description'}
                      ddnValue={cnf.cmncrdddnd}
                      ddnField={'cmncrdddnd'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmncrdclrd'}
                      clrValue={cnf.cmncrdclrd} />
                  </div>
                  :
                  wdtnm == 'tool_team_showcase' ?
                    <div className="customize-list">
                      <CmnCustomizeCard
                        label={'Header Title'}
                        ddnValue={cnf.cmnhdrddna}
                        ddnField={'cmnhdrddna'}
                        handleCnfChange={handleCnfChange}
                        handleColorPicker={handleColorPicker}
                        colorPick={colorPick}
                        clrField={'cmnhdrclra'}
                        clrValue={cnf.cmnhdrclra} />

                      <CmnCustomizeCard
                        label={'Header Caption'}
                        ddnValue={cnf.cmnhdrddnb}
                        ddnField={'cmnhdrddnb'}
                        handleCnfChange={handleCnfChange}
                        handleColorPicker={handleColorPicker}
                        colorPick={colorPick}
                        clrField={'cmnhdrclrb'}
                        clrValue={cnf.cmnhdrclrb} />

                      <CmnCustomizeCard
                        label={'Category'}
                        ddnValue={cnf.cmntbddn}
                        ddnField={'cmntbddn'}
                        handleCnfChange={handleCnfChange}
                        handleColorPicker={handleColorPicker}
                        colorPick={colorPick}
                        clrField={'cmntbclr'}
                        clrValue={cnf.cmntbclr} />

                      <CmnCustomizeCard
                        label={'Name'}
                        ddnValue={cnf.cmncrdddnb}
                        ddnField={'cmncrdddnb'}
                        handleCnfChange={handleCnfChange}
                        handleColorPicker={handleColorPicker}
                        colorPick={colorPick}
                        clrField={'cmncrdclrb'}
                        clrValue={cnf.cmncrdclrb} />

                      <CmnCustomizeCard
                        label={'Location'}
                        ddnValue={cnf.cmncrdddnc}
                        ddnField={'cmncrdddnc'}
                        handleCnfChange={handleCnfChange}
                        handleColorPicker={handleColorPicker}
                        colorPick={colorPick}
                        clrField={'cmncrdclrc'}
                        clrValue={cnf.cmncrdclrc} />

                      <CmnCustomizeCard
                        label={'Position'}
                        ddnValue={cnf.cmncrdddnd}
                        ddnField={'cmncrdddnd'}
                        handleCnfChange={handleCnfChange}
                        handleColorPicker={handleColorPicker}
                        colorPick={colorPick}
                        clrField={'cmncrdclrd'}
                        clrValue={cnf.cmncrdclrd} />

                      <CmnCustomizeCard
                        label={'Phone'}
                        ddnValue={cnf.cmncrdddne}
                        ddnField={'cmncrdddne'}
                        handleCnfChange={handleCnfChange}
                        handleColorPicker={handleColorPicker}
                        colorPick={colorPick}
                        clrField={'cmncrdclre'}
                        clrValue={cnf.cmncrdclre} />

                      <CmnCustomizeCard
                        label={'Email'}
                        ddnValue={cnf.cmncrdddnf}
                        ddnField={'cmncrdddnf'}
                        handleCnfChange={handleCnfChange}
                        handleColorPicker={handleColorPicker}
                        colorPick={colorPick}
                        clrField={'cmncrdclrf'}
                        clrValue={cnf.cmncrdclrf} />

                      <CmnCustomizeCard
                        label={'Website'}
                        ddnValue={cnf.cmncrdddng}
                        ddnField={'cmncrdddng'}
                        handleCnfChange={handleCnfChange}
                        handleColorPicker={handleColorPicker}
                        colorPick={colorPick}
                        clrField={'cmncrdclrg'}
                        clrValue={cnf.cmncrdclrg} />
                    </div>
                    :
                    wdtnm == 'tool_pricing' ?
                      <div className="customize-list">
                        <CmnCustomizeCard
                          label={'Header Title'}
                          ddnValue={cnf.cmnhdrddna}
                          ddnField={'cmnhdrddna'}
                          handleCnfChange={handleCnfChange}
                          handleColorPicker={handleColorPicker}
                          colorPick={colorPick}
                          clrField={'cmnhdrclra'}
                          clrValue={cnf.cmnhdrclra} />

                        <CmnCustomizeCard
                          label={'Header Caption'}
                          ddnValue={cnf.cmnhdrddnb}
                          ddnField={'cmnhdrddnb'}
                          handleCnfChange={handleCnfChange}
                          handleColorPicker={handleColorPicker}
                          colorPick={colorPick}
                          clrField={'cmnhdrclrb'}
                          clrValue={cnf.cmnhdrclrb} />

                        <CmnCustomizeCard
                          label={'Category'}
                          ddnValue={cnf.cmntbddn}
                          ddnField={'cmntbddn'}
                          handleCnfChange={handleCnfChange}
                          handleColorPicker={handleColorPicker}
                          colorPick={colorPick}
                          clrField={'cmntbclr'}
                          clrValue={cnf.cmntbclr} />

                        <CmnCustomizeCard
                          label={'Title'}
                          ddnValue={cnf.cmncrdddnb}
                          ddnField={'cmncrdddnb'}
                          handleCnfChange={handleCnfChange}
                          handleColorPicker={handleColorPicker}
                          colorPick={colorPick}
                          clrField={'cmncrdclrb'}
                          clrValue={cnf.cmncrdclrb} />

                        <CmnCustomizeCard
                          label={'Sort description'}
                          ddnValue={cnf.cmncrdddnc}
                          ddnField={'cmncrdddnc'}
                          handleCnfChange={handleCnfChange}
                          handleColorPicker={handleColorPicker}
                          colorPick={colorPick}
                          clrField={'cmncrdclrc'}
                          clrValue={cnf.cmncrdclrc} />

                        <CmnCustomizeCard
                          label={'Plan Detail'}
                          ddnValue={cnf.cmncrdddnd}
                          ddnField={'cmncrdddnd'}
                          handleCnfChange={handleCnfChange}
                          handleColorPicker={handleColorPicker}
                          colorPick={colorPick}
                          clrField={'cmncrdclrd'}
                          clrValue={cnf.cmncrdclrd} />

                        <CmnCustomizeCard
                          label={'Price'}
                          ddnValue={cnf.cmncrdddne}
                          ddnField={'cmncrdddne'}
                          handleCnfChange={handleCnfChange}
                          handleColorPicker={handleColorPicker}
                          colorPick={colorPick}
                          clrField={'cmncrdclre'}
                          clrValue={cnf.cmncrdclre} />

                        <CmnCustomizeCard
                          label={'Discount'}
                          ddnValue={cnf.cmncrdddnf}
                          ddnField={'cmncrdddnf'}
                          handleCnfChange={handleCnfChange}
                          handleColorPicker={handleColorPicker}
                          colorPick={colorPick}
                          clrField={'cmncrdclrf'}
                          clrValue={cnf.cmncrdclrf} />
                      </div>
                      :
                      wdtnm == 'tool_number_animation' ?
                        <div className="customize-list">
                          <CmnCustomizeCard
                            label={'Header Title'}
                            ddnValue={cnf.cmnhdrddna}
                            ddnField={'cmnhdrddna'}
                            handleCnfChange={handleCnfChange}
                            handleColorPicker={handleColorPicker}
                            colorPick={colorPick}
                            clrField={'cmnhdrclra'}
                            clrValue={cnf.cmnhdrclra} />

                          <CmnCustomizeCard
                            label={'Header Caption'}
                            ddnValue={cnf.cmnhdrddnb}
                            ddnField={'cmnhdrddnb'}
                            handleCnfChange={handleCnfChange}
                            handleColorPicker={handleColorPicker}
                            colorPick={colorPick}
                            clrField={'cmnhdrclrb'}
                            clrValue={cnf.cmnhdrclrb} />

                          <CmnCustomizeCard
                            label={'Number counter'}
                            ddnValue={cnf.cmncrdddna}
                            ddnField={'cmncrdddna'}
                            handleCnfChange={handleCnfChange}
                            handleColorPicker={handleColorPicker}
                            colorPick={colorPick}
                            clrField={'cmncrdclra'}
                            clrValue={cnf.cmncrdclra} />

                          <CmnCustomizeCard
                            label={'Title'}
                            ddnValue={cnf.cmncrdddnb}
                            ddnField={'cmncrdddnb'}
                            handleCnfChange={handleCnfChange}
                            handleColorPicker={handleColorPicker}
                            colorPick={colorPick}
                            clrField={'cmncrdclrb'}
                            clrValue={cnf.cmncrdclrb} />
                        </div>
                        :
                        // (currCategory.cn == 'review' || currCategory.cn == 'social') ?
                        //   <div className='customize-list'>
                        //     {
                        //       wdtnm == 'allinonereview' &&
                        //       <div className='customize-list'>
                        //         <CmnCustomizeCard
                        //           label={'Tab'}
                        //           ddnValue={cnf.cmntbddn}
                        //           ddnField={'cmntbddn'}
                        //           handleCnfChange={handleCnfChange}
                        //           handleColorPicker={handleColorPicker}
                        //           colorPick={colorPick}
                        //           clrField={'cmntbclr'}
                        //           clrValue={cnf.cmntbclr} />
                        //       </div>
                        //     }
                        //     <CmnCustomizeCard
                        //       label={'Header Title'}
                        //       ddnValue={cnf.cmnhdrddna}
                        //       ddnField={'cmnhdrddna'}
                        //       handleCnfChange={handleCnfChange}
                        //       handleColorPicker={handleColorPicker}
                        //       colorPick={colorPick}
                        //       clrField={'cmnhdrclra'}
                        //       clrValue={cnf.cmnhdrclra} />

                        //     <CmnCustomizeCard
                        //       label={'Header Caption'}
                        //       ddnValue={cnf.cmnhdrddnb}
                        //       ddnField={'cmnhdrddnb'}
                        //       handleCnfChange={handleCnfChange}
                        //       handleColorPicker={handleColorPicker}
                        //       colorPick={colorPick}
                        //       clrField={'cmnhdrclrb'}
                        //       clrValue={cnf.cmnhdrclrb} />
                        //   </div>
                        //   :
                        ''
            }
          </div>
        }

        {fnCheckFieldIsDisplayOrNot('other', currLayout) &&
          <div className="card card-editor card-bgcard mt-15">
            <div className="card-editor-block p-0 ">
              <div className='card-plan-div'>
                <label className="card-editor-title">Other</label>
                <UpgradePlanCard
                  handleUpgradePlan={handleUpgradePlan}
                />
              </div>
              <div className="customize-list">
                {cnf && cnf.crdlnkclr != undefined && fnCheckFieldIsDisplayOrNot('cnf.crdlnkclr', currCategory) &&
                  <div className="editor-field-list editor-toggle customize-dropdown customize-authoricon">
                    <label className="label-title">Link color</label>
                    <div className="d-flex">
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('crdlnkclr')} style={{ background: cnf.crdlnkclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'crdlnkclr' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.crdlnkclr} onChange={(e) => handleCnfChange('crdlnkclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }
                {cnf && cnf.crdintclr != undefined &&
                  <PostToggleCard
                    ttl={'Native color'}
                    fieldName={'crdintclr'}
                    value={cnf.crdintclr}
                    handleCnfChange={handleCnfChange} />

                  // <div className="editor-field-list editor-toggle customize-dropdown customize-isdate">
                  //   <label className="label-title">Native color</label>
                  //   <label className="switch">
                  //     <input type="checkbox" checked={cnf.crdintclr} onChange={(e) => handleCnfChange('crdintclr', e.target.checked)} />
                  //     <span className="slider round"></span>
                  //   </label>
                  // </div>
                }
                {cnf && cnf.crdstrclr != undefined &&
                  <div className="editor-field-list editor-toggle customize-dropdown customize-isaction">
                    <label className="label-title">Star color</label>
                    <div className="d-flex">
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('crdstrclr')} style={{ background: cnf.crdstrclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'crdstrclr' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.crdstrclr} onChange={(e) => handleCnfChange('crdstrclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }
                {cnf && cnf.crdatclr != undefined &&
                  <div className="editor-field-list editor-toggle customize-dropdown customize-isaction">
                    <label className="label-title">Author name</label>
                    <div className="d-flex editor-cardcmn-fntclr">
                      <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3 mb-0">
                        <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fszOption} value={cnf.crdatfnsz ? cnf.crdatfnsz.toString() : cnf.crdatfnsz} onChange={(e) => handleCnfChange('crdatfnsz', e.value)} />
                      </div>
                      <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3 mb-0">
                        <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fsylOption} value={cnf.crdatfnstl ? cnf.crdatfnstl.toString() : cnf.crdatfnstl} onChange={(e) => handleCnfChange('crdatfnstl', e.value)} />
                      </div>
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('crdatclr')} style={{ background: cnf.crdatclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'crdatclr' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.crdatclr} onChange={(e) => handleCnfChange('crdatclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }
                {cnf && cnf.crddtclr != undefined && currCardId !== '6319ab568b5efa1bb6e1599d' &&
                  <div className="editor-field-list editor-toggle customize-dropdown customize-isaction">
                    <label className="label-title">Date</label>
                    <div className="d-flex editor-cardcmn-fntclr">
                      <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3">
                        <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fszOption} value={cnf.crddtfnsz ? cnf.crddtfnsz.toString() : cnf.crddtfnsz} onChange={(e) => handleCnfChange('crddtfnsz', e.value)} />
                      </div>
                      <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3 mb-0">
                        <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fsylOption} value={cnf.crddtfnstl ? cnf.crddtfnstl.toString() : cnf.crddtfnstl} onChange={(e) => handleCnfChange('crddtfnstl', e.value)} />
                      </div>
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('crddtclr')} style={{ background: cnf.crddtclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'crddtclr' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.crddtclr} onChange={(e) => handleCnfChange('crddtclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }
                {cnf && cnf.crdfclr != undefined &&
                  <div className="editor-field-list editor-toggle">
                    <label className="label-title">Message</label>
                    <div className="d-flex editor-cardcmn-fntclr">
                      <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3">
                        <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fszOption} value={cnf.crdfsz ? cnf.crdfsz.toString() : cnf.crdfsz} onChange={(e) => handleCnfChange('crdfsz', e.value)} />
                      </div>
                      <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3 mb-0">
                        <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fsylOption} value={cnf.crdfstl ? cnf.crdfstl.toString() : cnf.crdfstl} onChange={(e) => handleCnfChange('crdfstl', e.value)} />
                      </div>
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('crdfclr')} style={{ background: cnf.crdfclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'crdfclr' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.crdfclr} onChange={(e) => handleCnfChange('crdfclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }
                {cnf && cnf.crdactnfnclr != undefined &&
                  <div className="editor-field-list editor-toggle customize-dropdown customize-isaction">
                    <label className="label-title">Action</label>
                    <div className="d-flex editor-cardcmn-fntclr">
                      <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3">
                        <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fszOption} value={cnf.crdactnfnsz ? cnf.crdactnfnsz.toString() : cnf.crdactnfnsz} onChange={(e) => handleCnfChange('crdactnfnsz', e.value)} />
                      </div>
                      <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3 mb-0">
                        <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fsylOption} value={cnf.crdactnfnstl ? cnf.crdactnfnstl.toString() : cnf.crdactnfnstl} onChange={(e) => handleCnfChange('crdactnfnstl', e.value)} />
                      </div>
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('crdactnfnclr')} style={{ background: cnf.crdactnfnclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'crdactnfnclr' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.crdactnfnclr} onChange={(e) => handleCnfChange('crdactnfnclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }
                {cnf && cnf.crdcptntxtclr != undefined &&
                  <div className="editor-field-list editor-toggle customize-dropdown customize-isaction">
                    <label className="label-title">Caption</label>
                    <div className="d-flex editor-cardcmn-fntclr">
                      <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3">
                        <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fszOption} value={cnf.crdcptntxtsz ? cnf.crdcptntxtsz.toString() : cnf.crdcptntxtsz} onChange={(e) => handleCnfChange('crdcptntxtsz', e.value)} />
                      </div>
                      <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3 mb-0">
                        <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fsylOption} value={cnf.crdcptntxtstl ? cnf.crdcptntxtstl.toString() : cnf.crdcptntxtstl} onChange={(e) => handleCnfChange('crdcptntxtstl', e.value)} />
                      </div>
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('crdcptntxtclr')} style={{ background: cnf.crdcptntxtclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'crdcptntxtclr' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.crdcptntxtclr} onChange={(e) => handleCnfChange('crdcptntxtclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }

                {cnf && cnf.crdhtgfntclr != undefined &&
                  <div className="editor-field-list editor-toggle">
                    <label className="label-title">Tag font color </label>
                    <div className="d-flex editor-cardcmn-fntclr">
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('crdhtgfntclr')} style={{ background: cnf.crdhtgfntclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'crdhtgfntclr' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.crdhtgfntclr} onChange={(e) => handleCnfChange('crdhtgfntclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }

                {cnf && cnf.crdhtgbgclr != undefined &&
                  <div className="editor-field-list editor-toggle">
                    <label className="label-title">Tag background color</label>
                    <div className="d-flex editor-cardcmn-fntclr">
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('crdhtgbgclr')} style={{ background: cnf.crdhtgbgclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'crdhtgbgclr' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.crdhtgbgclr} onChange={(e) => handleCnfChange('crdhtgbgclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </TabPanel>
      {/* popup */}
      {cnf && cnf.crdclkact == '2' &&
        <TabPanel className="tabs-secstyle-panel tabs-panel-appearance">
          <div className="card card-editor card-customize mt-15">
            <div className="card-editor-block p-0">
              <div className='card-plan-div'>
                <label className="card-editor-title">Background</label>
                <UpgradePlanCard
                  handleUpgradePlan={handleUpgradePlan}
                />
              </div>
              <div className="customize-list">
                {
                  cnf && cnf.ppbg != undefined && fnCheckFieldIsDisplayOrNot('cnf.ppbg', currPopup) &&
                  <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                    <label className="label-title">Color</label>
                    <div className="d-flex">
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('ppbg')} style={{ background: cnf.ppbg }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'ppbg' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.ppbg} onChange={(e) => handleCnfChange('ppbg', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }

                {cnf && cnf.ppbkdrp != undefined &&
                  <div className="editor-field-list editor-toggle customize-dropdown customize-isdate">
                    <label className="label-title">Backdrop color</label>
                    <div className="d-flex">
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('ppbkdrp')} style={{ background: cnf.ppbkdrp }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'ppbkdrp' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.ppbkdrp} onChange={(e) => handleCnfChange('ppbkdrp', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }
                {cnf && cnf.ppcrdbg != undefined &&
                  <div className="editor-field-list editor-toggle customize-dropdown customize-isaction mb-0">
                    <label className="label-title">Background color</label>
                    <div className="d-flex">
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('ppcrdbg')} style={{ background: cnf.ppcrdbg }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'ppcrdbg' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.ppcrdbg} onChange={(e) => handleCnfChange('ppcrdbg', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          {cnf &&
            <div className="card card-editor card-appren-popup mt-15">
              <div className="card-editor-block p-0">
                <div className='card-plan-div'>
                  <label className="card-editor-title">Border</label>
                  <UpgradePlanCard
                    handleUpgradePlan={handleUpgradePlan}
                  />
                </div>
                <div className="customize-list">
                  <div className="editor-field-list editor-toggle border-dropdown border-dropdown-clr">
                    <label className="label-title">Color</label>
                    <div className="d-flex">
                      <div className={cnf.ppbrdrd == '0' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('ppbrdrd', '0')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="13.333" height="13.333" viewBox="0 0 13.333 13.333">
                          <path id="Path_12730" data-name="Path 12730" d="M2.5,4.167V17.5H4.068V5.735H15.833V4.167Z" transform="translate(-2.5 -4.167)" fill="#90adcc" fillRule="evenodd" />
                        </svg>
                      </div>
                      <div className={cnf.ppbrdrd == '5' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('ppbrdrd', '5')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="13.333" height="13.333" viewBox="0 0 13.333 13.333">
                          <path id="Path_12731" data-name="Path 12731" d="M8.513,4.167A6.013,6.013,0,0,0,2.5,10.006l0,.174V17.5H4.068V10.18A4.445,4.445,0,0,1,8.357,5.738l.156,0h7.32V4.167Z" transform="translate(-2.5 -4.167)" fill="#90adcc" fillRule="evenodd" />
                        </svg>
                      </div>
                      <div className={cnf.ppbrdrd == '10' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('ppbrdrd', '10')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="13.333" height="13.333" viewBox="0 0 13.333 13.333">
                          <path id="Path_12732" data-name="Path 12732" d="M15.049,4.167A12.549,12.549,0,0,0,2.5,16.493l0,.223V17.5H4.068v-.784A10.982,10.982,0,0,1,14.838,5.737l.21,0h.785V4.167Z" transform="translate(-2.5 -4.167)" fill="#90adcc" fillRule="evenodd" />
                        </svg>
                      </div>
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('ppbrdclr')} style={{ background: cnf.ppbrdclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'ppbrdclr' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.ppbrdclr} onChange={(e) => handleCnfChange('ppbrdclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                  <div className="editor-tworow-part editor-tworow-border pb-0 px-0">
                    <div className="editor-tworow-block py-0">
                      <div className="editor-tworow-col editor-tworow-bdrclr">
                        <label className="label-title">Size</label>
                        <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={brdSizeOption} value={cnf.ppbrdsz != undefined ? cnf.ppbrdsz.toString() : cnf.ppbrdsz} onChange={(e) => handleCnfChange('ppbrdsz', e.value)} />
                      </div>
                      <div className="editor-tworow-col editor-tworow-bdrsize">
                        <label className="label-title">Style</label>
                        <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={brdStylOption} value={cnf.ppbrdstl.toString()} onChange={(e) => handleCnfChange('ppbrdstl', e.value)} />
                      </div>
                      <div className="editor-tworow-col editor-tworow-style">
                        <label className="label-title">Radius</label>
                        <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={brdRdsOption} value={cnf.ppbrdrd != undefined ? cnf.ppbrdrd.toString() : cnf.ppbrdrd} onChange={(e) => handleCnfChange('ppbrdrd', e.value)} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          {cnf &&
            <div className="card card-editor card-appren-popup mt-15">
              <div className="card-editor-block p-0">
                <div className='card-plan-div'>
                  <label className="card-editor-title">Shadow</label>
                  <UpgradePlanCard
                    handleUpgradePlan={handleUpgradePlan}
                  />
                </div>
                <div className="customize-list">
                  <div className="editor-field-list  editor-toggle border-dropdown border-dropdown-clr">
                    <label className="label-title">Color</label>
                    <div className="d-flex">
                      <div className={cnf.ppshdvl == '0' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('ppshdnone')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                          <g id="Rectangle_1639" data-name="Rectangle 1639" fill="none" stroke="#90adcc" strokeWidth="1">
                            <rect width="14" height="14" stroke="none" />
                            <rect x="0.5" y="0.5" width="13" height="13" fill="none" />
                          </g>
                        </svg>
                      </div>
                      <div className={cnf.ppshdvl == '5' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('ppshdleft')}>
                        <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
                          <defs>
                            <filter id="Path_12735" x="0" y="0" width="16" height="16" filterUnits="userSpaceOnUse">
                              <feOffset dx="2" dy="2" input="SourceAlpha" />
                              <feGaussianBlur result="blur" />
                              <feFlood floodOpacity="0.322" />
                              <feComposite operator="in" in2="blur" />
                              <feComposite in="SourceGraphic" />
                            </filter>
                          </defs>
                          <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_12735)">
                            <g id="Path_12735-2" data-name="Path 12735" fill="none">
                              <path d="M0,0H14V14H0Z" stroke="none" />
                              <path d="M 1 1 L 1 13 L 13 13 L 13 1 L 1 1 M 0 0 L 14 0 L 14 14 L 0 14 L 0 0 Z" stroke="none" fill="#90adcc" />
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div className={cnf.ppshdvl == '-5' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('ppshdright')}>
                        <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
                          <defs>
                            <filter id="Path_12736" x="0" y="0" width="16" height="16" filterUnits="userSpaceOnUse">
                              <feOffset dx="-2" dy="-2" input="SourceAlpha" />
                              <feGaussianBlur result="blur" />
                              <feFlood floodOpacity="0.322" />
                              <feComposite operator="in" in2="blur" />
                              <feComposite in="SourceGraphic" />
                            </filter>
                          </defs>
                          <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_12736)">
                            <g id="Path_12736-2" data-name="Path 12736" transform="translate(2 2)" fill="none">
                              <path d="M0,0H14V14H0Z" stroke="none" />
                              <path d="M 1 1 L 1 13 L 13 13 L 13 1 L 1 1 M 0 0 L 14 0 L 14 14 L 0 14 L 0 0 Z" stroke="none" fill="#90adcc" />
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div className="colorpicker-box" id="color_code">
                        <div className="colorpicker" onClick={() => handleColorPicker('ppshdclr')} style={{ background: cnf.ppshdclr }}>
                          <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                            <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                            <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                            <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                          </svg>
                        </div>
                        {
                          colorPick == 'ppshdclr' ?
                            <div className="colorPickPopover">
                              <SketchPicker color={cnf.ppshdclr} onChange={(e) => handleCnfChange('ppshdclr', e.rgb, 'rgb')} />
                            </div>
                            : null
                        }
                      </div>
                    </div>
                  </div>
                  <div className="editor-tworow-part editor-tworow-border pb-0 px-0">
                    <div className="editor-tworow-block py-0">
                      <div className="editor-tworow-col editor-tworow-bdrclr">
                        <label className="label-title">Shadow-X</label>
                        <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={shdOption} value={cnf.ppshdhz != undefined ? cnf.ppshdhz.toString() : cnf.ppshdhz} onChange={(e) => handleCnfChange('ppshdhz', e.value)} />
                      </div>
                      <div className="editor-tworow-col editor-tworow-bdrsize">
                        <label className="label-title">Shadow-Y</label>
                        <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={shdOption} value={cnf.ppshdvl != undefined ? cnf.ppshdvl.toString() : cnf.ppshdvl} onChange={(e) => handleCnfChange('ppshdvl', e.value)} />
                      </div>
                      <div className="editor-tworow-col editor-tworow-style">
                        <label className="label-title">Blur</label>
                        <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={shdblrOption} value={cnf.ppshdblr != undefined ? cnf.ppshdblr.toString() : cnf.ppshdblr} onChange={(e) => handleCnfChange('ppshdblr', e.value)} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          {(wdtnm == 'job_board' || wdtnm == 'tool_team_showcase') &&
            <div className="card card-editor card-bgcard mt-20">
              <div className='card-plan-div'>
                <label className="card-editor-title">Customize</label>
                <UpgradePlanCard
                  handleUpgradePlan={handleUpgradePlan}
                />
              </div>
              {wdtnm == 'job_board' ?
                <div className="customize-list">
                  <CmnCustomizeCard
                    label={'Title'}
                    ddnValue={cnf.cmnppddna}
                    ddnField={'cmnppddna'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmnppclra'}
                    clrValue={cnf.cmnppclra} />

                  <CmnCustomizeCard
                    label={'Location'}
                    ddnValue={cnf.cmnppddnb}
                    ddnField={'cmnppddnb'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmnppclrb'}
                    clrValue={cnf.cmnppclrb} />

                  <CmnCustomizeCard
                    label={'Salary'}
                    ddnValue={cnf.cmnppddnc}
                    ddnField={'cmnppddnc'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmnppclrc'}
                    clrValue={cnf.cmnppclrc} />

                  <CmnCustomizeCard
                    label={'Designation'}
                    ddnValue={cnf.cmnppddnd}
                    ddnField={'cmnppddnd'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmnppclrd'}
                    clrValue={cnf.cmnppclrd} />

                  <CmnCustomizeCard
                    label={'Job type color'}
                    ddnValue={cnf.cmnppddne}
                    ddnField={'cmnppddne'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmnppclre'}
                    clrValue={cnf.cmnppclre} />

                  <CmnCustomizeCard
                    label={'Description'}
                    ddnValue={cnf.cmnppddnf}
                    ddnField={'cmnppddnf'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmnppclrf'}
                    clrValue={cnf.cmnppclrf} />
                </div>
                :
                wdtnm == 'tool_team_showcase' ?
                  <div className="customize-list">
                    <CmnCustomizeCard
                      label={'Name'}
                      ddnValue={cnf.cmnppddna}
                      ddnField={'cmnppddna'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmnppclra'}
                      clrValue={cnf.cmnppclra} />

                    <CmnCustomizeCard
                      label={'Location'}
                      ddnValue={cnf.cmnppddnb}
                      ddnField={'cmnppddnb'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmnppclrb'}
                      clrValue={cnf.cmnppclrb} />

                    <CmnCustomizeCard
                      label={'Position'}
                      ddnValue={cnf.cmnppddnc}
                      ddnField={'cmnppddnc'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmnppclrc'}
                      clrValue={cnf.cmnppclrc} />

                    <CmnCustomizeCard
                      label={'Phone'}
                      ddnValue={cnf.cmnppddnd}
                      ddnField={'cmnppddnd'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmnppclrd'}
                      clrValue={cnf.cmnppclrd} />

                    <CmnCustomizeCard
                      label={'Email'}
                      ddnValue={cnf.cmnppddne}
                      ddnField={'cmnppddne'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmnppclre'}
                      clrValue={cnf.cmnppclre} />

                    <CmnCustomizeCard
                      label={'Website'}
                      ddnValue={cnf.cmnppddnf}
                      ddnField={'cmnppddnf'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmnppclrf'}
                      clrValue={cnf.cmnppclrf} />

                    <CmnCustomizeCard
                      label={'Description'}
                      ddnValue={cnf.cmnppddng}
                      ddnField={'cmnppddng'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmnppclrg'}
                      clrValue={cnf.cmnppclrg} />
                  </div>
                  :
                  ''
              }
            </div>
          }

          {fnCheckFieldIsDisplayOrNot('other', currLayout) &&
            <div className="card card-editor card-appren-popup card--popup-other mt-15">
              <div className="card-editor-block p-0">
                <div className='card-plan-div'>
                  <label className="card-editor-title">Other</label>
                  <UpgradePlanCard
                    handleUpgradePlan={handleUpgradePlan}
                  />
                </div>
                <div className="customize-list">
                  {cnf && cnf.pplnkclr != undefined && fnCheckFieldIsDisplayOrNot('cnf.pplnkclr', currCategory) &&
                    <div className="editor-field-list editor-toggle customize-dropdown customize-authoricon">
                      <label className="label-title">Link color</label>
                      <div className="d-flex">
                        <div className="colorpicker-box" id="color_code">
                          <div className="colorpicker" onClick={() => handleColorPicker('pplnkclr')} style={{ background: cnf.pplnkclr }}>
                            <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                              <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                              <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                              <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                            </svg>
                          </div>
                          {
                            colorPick == 'pplnkclr' ?
                              <div className="colorPickPopover">
                                <SketchPicker color={cnf.pplnkclr} onChange={(e) => handleCnfChange('pplnkclr', e.rgb, 'rgb')} />
                              </div>
                              : null
                          }
                        </div>
                      </div>
                    </div>
                  }
                  {cnf && cnf.ppstrclr != undefined &&
                    <div className="editor-field-list editor-toggle customize-dropdown customize-isaction">
                      <label className="label-title">Star color</label>
                      <div className="d-flex">
                        <div className="colorpicker-box" id="color_code">
                          <div className="colorpicker" onClick={() => handleColorPicker('ppstrclr')} style={{ background: cnf.ppstrclr }}>
                            <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                              <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                              <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                              <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                            </svg>
                          </div>
                          {
                            colorPick == 'ppstrclr' ?
                              <div className="colorPickPopover">
                                <SketchPicker color={cnf.ppstrclr} onChange={(e) => handleCnfChange('ppstrclr', e.rgb, 'rgb')} />
                              </div>
                              : null
                          }
                        </div>
                      </div>
                    </div>
                  }
                  {cnf && cnf.ppatclr &&
                    <div className="editor-field-list editor-toggle customize-dropdown customize-isaction">
                      <label className="label-title">Author name</label>
                      <div className="d-flex editor-cardcmn-fntclr">
                        <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3">
                          <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fszOption} value={cnf.ppatfnsz ? cnf.ppatfnsz.toString() : cnf.ppatfnsz} onChange={(e) => handleCnfChange('ppatfnsz', e.value)} />
                        </div>
                        <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3 mb-0">
                          <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fsylOption} value={cnf.ppatfnstl ? cnf.ppatfnstl.toString() : cnf.ppatfnstl} onChange={(e) => handleCnfChange('ppatfnstl', e.value)} />
                        </div>
                        <div className="colorpicker-box" id="color_code">
                          <div className="colorpicker" onClick={() => handleColorPicker('ppatclr')} style={{ background: cnf.ppatclr }}>
                            <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                              <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                              <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                              <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                            </svg>
                          </div>
                          {
                            colorPick == 'ppatclr' ?
                              <div className="colorPickPopover">
                                <SketchPicker color={cnf.ppatclr} onChange={(e) => handleCnfChange('ppatclr', e.rgb, 'rgb')} />
                              </div>
                              : null
                          }
                        </div>
                      </div>
                    </div>
                  }
                  {cnf && cnf.ppdtclr &&
                    <div className="editor-field-list editor-toggle customize-dropdown customize-isaction">
                      <label className="label-title">Date</label>
                      <div className="d-flex editor-cardcmn-fntclr">
                        <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3">
                          <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fszOption} value={cnf.ppdtfnsz ? cnf.ppdtfnsz.toString() : cnf.ppdtfnsz} onChange={(e) => handleCnfChange('ppdtfnsz', e.value)} />
                        </div>
                        <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3 mb-0">
                          <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fsylOption} value={cnf.ppdtfnstl ? cnf.ppdtfnstl.toString() : cnf.ppdtfnstl} onChange={(e) => handleCnfChange('ppdtfnstl', e.value)} />
                        </div>
                        <div className="colorpicker-box" id="color_code">
                          <div className="colorpicker" onClick={() => handleColorPicker('ppdtclr')} style={{ background: cnf.ppdtclr }}>
                            <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                              <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                              <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                              <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                            </svg>
                          </div>
                          {
                            colorPick == 'ppdtclr' ?
                              <div className="colorPickPopover">
                                <SketchPicker color={cnf.ppdtclr} onChange={(e) => handleCnfChange('ppdtclr', e.rgb, 'rgb')} />
                              </div>
                              : null
                          }
                        </div>
                      </div>
                    </div>
                  }
                  {cnf && cnf.ppfsz != undefined &&
                    <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                      <label className="label-title">Message</label>
                      <div className="d-flex editor-cardcmn-fntclr">
                        <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3">
                          <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fszOption} value={cnf.ppfsz ? cnf.ppfsz.toString() : cnf.ppfsz} onChange={(e) => handleCnfChange('ppfsz', e.value)} />
                        </div>
                        <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3 mb-0">
                          <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fsylOption} value={cnf.ppfstl ? cnf.ppfstl.toString() : cnf.ppfstl} onChange={(e) => handleCnfChange('ppfstl', e.value)} />
                        </div>
                        <div className="colorpicker-box" id="color_code">
                          <div className="colorpicker" onClick={() => handleColorPicker('ppfclr')} style={{ background: cnf.ppfclr }}>
                            <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                              <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                              <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                              <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                            </svg>
                          </div>
                          {
                            colorPick == 'ppfclr' ?
                              <div className="colorPickPopover">
                                <SketchPicker color={cnf.ppfclr} onChange={(e) => handleCnfChange('ppfclr', e.rgb, 'rgb')} />
                              </div>
                              : null
                          }
                        </div>
                      </div>
                    </div>
                  }
                  {cnf && cnf.ppactnfnclr != undefined &&
                    <div className="editor-field-list editor-toggle customize-dropdown customize-isaction">
                      <label className="label-title">Action</label>
                      <div className="d-flex editor-cardcmn-fntclr">
                        <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3">
                          <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fszOption} value={cnf.ppactnfnsz ? cnf.ppactnfnsz.toString() : cnf.ppactnfnsz} onChange={(e) => handleCnfChange('ppactnfnsz', e.value)} />
                        </div>
                        <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3 mb-0">
                          <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fsylOption} value={cnf.ppactnfnstl ? cnf.ppactnfnstl.toString() : cnf.ppactnfnstl} onChange={(e) => handleCnfChange('ppactnfnstl', e.value)} />
                        </div>
                        <div className="colorpicker-box" id="color_code">
                          <div className="colorpicker" onClick={() => handleColorPicker('ppactnfnclr')} style={{ background: cnf.ppactnfnclr }}>
                            <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                              <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                              <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                              <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                            </svg>
                          </div>
                          {
                            colorPick == 'ppactnfnclr' ?
                              <div className="colorPickPopover">
                                <SketchPicker color={cnf.ppactnfnclr} onChange={(e) => handleCnfChange('ppactnfnclr', e.rgb, 'rgb')} />
                              </div>
                              : null
                          }
                        </div>
                      </div>
                    </div>
                  }
                  {cnf && cnf.ppcptntxtclr != undefined &&
                    <div className="editor-field-list editor-toggle customize-dropdown customize-isaction">
                      <label className="label-title">Caption</label>
                      <div className="d-flex editor-cardcmn-fntclr">
                        <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3">
                          <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fszOption} value={cnf.ppcptntxtsz ? cnf.ppcptntxtsz.toString() : cnf.ppcptntxtsz} onChange={(e) => handleCnfChange('ppcptntxtsz', e.value)} />
                        </div>
                        <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3 mb-0">
                          <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fsylOption} value={cnf.ppcptntxtstl ? cnf.ppcptntxtstl.toString() : cnf.ppcptntxtstl} onChange={(e) => handleCnfChange('ppcptntxtstl', e.value)} />
                        </div>
                        <div className="colorpicker-box" id="color_code">
                          <div className="colorpicker" onClick={() => handleColorPicker('ppcptntxtclr')} style={{ background: cnf.ppcptntxtclr }}>
                            <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                              <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                              <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                              <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                            </svg>
                          </div>
                          {
                            colorPick == 'ppcptntxtclr' ?
                              <div className="colorPickPopover">
                                <SketchPicker color={cnf.ppcptntxtclr} onChange={(e) => handleCnfChange('ppcptntxtclr', e.rgb, 'rgb')} />
                              </div>
                              : null
                          }
                        </div>
                      </div>
                    </div>
                  }
                  {cnf && cnf.pphtgfntclr != undefined &&
                    <div className="editor-field-list editor-toggle">
                      <label className="label-title">Tag font color</label>
                      <div className="d-flex editor-cardcmn-fntclr">
                        <div className="colorpicker-box" id="color_code">
                          <div className="colorpicker" onClick={() => handleColorPicker('pphtgfntclr')} style={{ background: cnf.pphtgfntclr }}>
                            <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                              <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                              <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                              <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                            </svg>
                          </div>
                          {
                            colorPick == 'pphtgfntclr' ?
                              <div className="colorPickPopover">
                                <SketchPicker color={cnf.pphtgfntclr} onChange={(e) => handleCnfChange('pphtgfntclr', e.rgb, 'rgb')} />
                              </div>
                              : null
                          }
                        </div>
                      </div>
                    </div>
                  }

                  {cnf && cnf.pphtgbgclr != undefined &&
                    <div className="editor-field-list editor-toggle">
                      <label className="label-title">Tag background color</label>
                      <div className="d-flex editor-cardcmn-fntclr">
                        <div className="colorpicker-box" id="color_code">
                          <div className="colorpicker" onClick={() => handleColorPicker('pphtgbgclr')} style={{ background: cnf.pphtgbgclr }}>
                            <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                              <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                              <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                              <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                            </svg>
                          </div>
                          {
                            colorPick == 'pphtgbgclr' ?
                              <div className="colorPickPopover">
                                <SketchPicker color={cnf.pphtgbgclr} onChange={(e) => handleCnfChange('pphtgbgclr', e.rgb, 'rgb')} />
                              </div>
                              : null
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </TabPanel>
      }
    </Tabs>
  );
};

export default AppearanceCard;


// WEBPACK FOOTER //
// ./src/components/Widget/AppearanceCard.js